import { Flex, PageWrapper, Table } from '@approvalmax/ui/src/components';
import range from 'lodash/range';
import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';

export const Loading = memo(() => {
    return (
        <PageWrapper>
            <PageWrapper.Content spacingTop={24}>
                <Flex direction='column' spacing='32'>
                    <Flex>
                        {range(3).map((index) => (
                            <Flex key={index} direction='column' spacing='8'>
                                <Skeleton width={100} height={12} />

                                <Skeleton width={200} height={40} />
                            </Flex>
                        ))}
                    </Flex>

                    <Flex container>
                        <Flex size={12} direction='column'>
                            <Skeleton width={160} height={20} />

                            <Skeleton width='100%' height={180} />
                        </Flex>

                        <Flex size={12} direction='column'>
                            <Skeleton width={160} height={20} />

                            <Skeleton width='100%' height={180} />
                        </Flex>
                    </Flex>

                    <Flex direction='column'>
                        <Flex justifyContent='space-between' alignItems='center'>
                            <Skeleton width={100} height={20} />

                            <Skeleton width={160} height={28} />
                        </Flex>

                        <Table
                            progress
                            bordered
                            data={[]}
                            columns={range(5).map((index) => ({
                                id: String(index),
                                name: '',
                            }))}
                        />
                    </Flex>
                </Flex>
            </PageWrapper.Content>
        </PageWrapper>
    );
});

Loading.displayName = 'Loading';
